import { useRef, useState } from 'react';

interface Props {
  onFile: (name: string, base64: string, sizeBytes: number) => void;
  accept?: string;
  maxBytes?: number;
  currentName?: string | null;
}

export function FileUpload({
  onFile,
  accept = '.pdf,.docx,.doc,.xls,.xlsx,.jpg,.jpeg,.png',
  maxBytes = 10 * 1024 * 1024,
  currentName,
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string | null>(null);

  const onPick = async (file: File | undefined): Promise<void> => {
    if (!file) return;
    if (file.size > maxBytes) {
      setError(`Файл больше ${Math.round(maxBytes / 1024 / 1024)} МБ`);
      return;
    }
    setError(null);
    const b64 = await new Promise<string>((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => {
        const result = r.result as string;
        resolve(result.split(',')[1] ?? '');
      };
      r.onerror = () => reject(new Error('read failed'));
      r.readAsDataURL(file);
    });
    onFile(file.name, b64, file.size);
  };

  return (
    <div>
      <button
        type="button"
        className="btn-secondary w-full"
        onClick={() => inputRef.current?.click()}
      >
        {currentName ? `Заменить: ${currentName}` : 'Прикрепить файл (вставка)'}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => void onPick(e.target.files?.[0])}
      />
      {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
    </div>
  );
}
